import React, { useContext, useState } from "react";
import { APIContext } from "../../api";
import { toast } from "react-toastify";
import { PulseLoader } from "react-spinners";
import {
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  Box,
  Alert,
  AlertIcon,
} from "@chakra-ui/react";

function AppSumoBannerToggle({
  open,
  setOpen,
  userSub,
  userEmail,
  subscription,
  userData,
  onBannerToggled,
}) {
  const { toggleAppSumoBanner } = useContext(APIContext);
  const [isToggling, setIsToggling] = useState(false);

  // Check if user is an AppSumo user
  const isAppSumoUser = subscription?.platform === "appsumo" || 
                       subscription?.plan?.startsWith?.("appsumo");

  // Check current banner status
  const isBannerHidden = userData?.appsumo_review_image_submitted === true;
  console.log(userData);
  const handleToggle = async (showBanner) => {
    if (isToggling) {
      return;
    }

    setIsToggling(true);

    try {
      await toggleAppSumoBanner(userSub, showBanner);
      
      toast.success(
        showBanner 
          ? "AppSumo banner has been enabled for this user" 
          : "AppSumo banner has been disabled for this user",
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
      
      // Update the user data locally
      if (onBannerToggled) {
        onBannerToggled(showBanner);
      }
      
      setOpen(false);
    } catch (error) {
      console.error("Error toggling AppSumo banner:", error);
      toast.error("Failed to toggle AppSumo banner. Please try again.", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
      setIsToggling(false);
    }
  };

  if (!isAppSumoUser) {
    return null; // Don't render anything for non-AppSumo users
  }

  return (
    <>
      <Modal
        blockScrollOnMount={false}
        isOpen={open}
        onClose={() => {
          setOpen(false);
        }}
        size="md"
        borderRadius="21px"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalHeader mt="20px" textAlign="center" fontSize="24px">
            AppSumo Banner Management
          </ModalHeader>
          <ModalBody mx="10px" p="10px" borderRadius="20px">
            <div className="w-full p-6 text-grigora-base cursor-default">
              <Alert status="info" className="mb-4">
                <AlertIcon />
                <Text>
                  This user has an AppSumo subscription. You can control whether 
                  they see the AppSumo review banner or not.
                </Text>
              </Alert>

              <div className="mb-4">
                <Text className="font-semibold mb-2">Current Status:</Text>
                <Text className={`px-3 py-2 rounded-lg ${isBannerHidden ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'}`}>
                  {isBannerHidden ? "Banner is Hidden" : "Banner is Visible"}
                </Text>
              </div>

              <div className="mb-4">
                <Text className="font-semibold mb-2">User Details:</Text>
                <Text className="text-sm text-gray-600">Email: {userEmail}</Text>
                <Text className="text-sm text-gray-600">Plan: {subscription?.plan || "Unknown"}</Text>
              </div>

              <div className="flex gap-3 mt-6">
                <Button
                  onClick={() => handleToggle(true)}
                  disabled={isToggling || !isBannerHidden}
                  colorScheme="green"
                  flex={1}
                >
                  {isToggling ? (
                    <PulseLoader size={8} color="white" />
                  ) : (
                    "Show Banner"
                  )}
                </Button>
                
                <Button
                  onClick={() => handleToggle(false)}
                  disabled={isToggling || isBannerHidden}
                  colorScheme="red"
                  flex={1}
                >
                  {isToggling ? (
                    <PulseLoader size={8} color="white" />
                  ) : (
                    "Hide Banner"
                  )}
                </Button>
              </div>
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export default AppSumoBannerToggle;
